import {
  DefaultBallotDetailsContent,
  MirvacBallotDetailsContent,
  QldAffordableBallotDetailsContent,
} from 'app/components/Ballot/Details'
import {
  modalBodyQldAffordable,
  modalBodyVarcVic,
} from 'app/components/Ballot/TermAndConditions/CollectionPolicyModal'
import {
  MIRVAC_TEAM_NAME,
  QLD_AFFORDABLE_TEAM_NAME,
  QldAffordableBallotTextPropertyPage,
  VARCBallotTextPropertyPage,
} from 'app/utils/text/helpers'

export const ballotDetailsContent = (teamSlug: string) => {
  switch (teamSlug) {
    case MIRVAC_TEAM_NAME:
      return <MirvacBallotDetailsContent />
    case QLD_AFFORDABLE_TEAM_NAME:
      return <QldAffordableBallotDetailsContent />
    default:
      return <DefaultBallotDetailsContent />
  }
}

export const ballotDataCollectionPolicy = (teamSlug: string) => {
  switch (teamSlug) {
    case QLD_AFFORDABLE_TEAM_NAME:
      return modalBodyQldAffordable
    default:
      return modalBodyVarcVic
  }
}

export const ballotDataCollectionPolicyModalHeading = (teamSlug: string) => {
  switch (teamSlug) {
    case QLD_AFFORDABLE_TEAM_NAME:
      return 'National Affordable Housing Data Collection Policy'
    default:
      return 'Homes Victoria Data Collection Policy'
  }
}

export const ballotPropertyPageText = (teamSlug: string) => {
  switch (teamSlug) {
    case QLD_AFFORDABLE_TEAM_NAME:
      return <QldAffordableBallotTextPropertyPage />
    default:
      return <VARCBallotTextPropertyPage />
  }
}

export const getSchemeFromTeamSlug = (teamSlug: string) => {
  switch (teamSlug) {
    case QLD_AFFORDABLE_TEAM_NAME:
      return 'AFFORDABLE'
    default:
      return 'VARC'
  }
}

export const ADULT = 'Adult'
export const SOLEPARENT = 'SoleParent'
export const CHILD = 'Child'
export const OCCUPANT = 'Occupant'

export const calculateHouseholdIncomeThreshold = (
  adults: number = 1,
  children: number = 0,
  ballotsHouseholdIncomeLimit: { type: string; income: number }[] = [],
) => {
  const incomeLimits = ballotsHouseholdIncomeLimit || []
  const nahcHouseholdIncomeThresholds = {
    [ADULT]: incomeLimits?.find(({ type }) => type === ADULT)?.income,
    [SOLEPARENT]: incomeLimits?.find(({ type }) => type === SOLEPARENT)?.income,
    [OCCUPANT]: incomeLimits?.find(({ type }) => type === OCCUPANT)?.income,
    [CHILD]: incomeLimits?.find(({ type }) => type === CHILD)?.income,
  }

  const adultsMinusApplicant = adults - 1

  if (children === 0) {
    return (
      (nahcHouseholdIncomeThresholds[ADULT] ?? 0) +
      (nahcHouseholdIncomeThresholds[OCCUPANT] ?? 0) * adultsMinusApplicant
    )
  } else if (adults === 1) {
    return (
      (nahcHouseholdIncomeThresholds[SOLEPARENT] ?? 0) +
      (nahcHouseholdIncomeThresholds[CHILD] ?? 0) * children
    )
  } else {
    return (
      (nahcHouseholdIncomeThresholds[ADULT] ?? 0) +
      (nahcHouseholdIncomeThresholds[OCCUPANT] ?? 0) * adultsMinusApplicant +
      (nahcHouseholdIncomeThresholds[CHILD] ?? 0) * children
    )
  }
}
